import { jsx as _jsx } from "react/jsx-runtime";
import { edgeTypeMatrix } from '@iotv/datamodel';
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useContext } from 'react';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { isAdminRole } from '../../../../helpers/access';
import { ObjectTree } from '../../../../v2/components/generic/ObjectTree';
import { ContextMenu } from '../../ContextMenuV2/ContextMenu';
import { CustFolderClickWrapper } from '../../clickWrappers/helpers';
import { customerRollingProgrammesTreeDef } from '../RollingProgrammes';
dayjs.extend(utc);
export const RollingProgrammes = ({ applicationData, contextCustomer, transactionFunctions, userFunctions, user, roleArbitrationInstance }) => {
    const [{ userSelectedGroup }] = useContext(AppMainViewContext);
    const rollingProgrammesContextMenu = isAdminRole(userSelectedGroup)
        ? contextCustomer && (_jsx(ContextMenu, { label: "Rolling Programmes", hideDelete: true, popUpElement: null, contextObject: contextCustomer, edgeTypeIdFilter: [edgeTypeMatrix.Customer.EntityRollingProgramme.customer_has_entity_rolling_programme.edgeTypeId], defaultCreationProperties: {
                startTimeUtcSeconds: dayjs().second(0).millisecond(0).add(1, 'hour').unix(),
            }, ascendentAccessor: { ascendentAccessor: null, contextObject: contextCustomer } }))
        : 'Rolling Programmes';
    return (contextCustomer && (_jsx(TreeItem, { itemId: "RollingProgrammes", label: rollingProgrammesContextMenu, children: _jsx(ObjectTree, { nodeEdgeMapper: applicationData,
            queryPaths: [customerRollingProgrammesTreeDef],
            contextObjects: [contextCustomer],
            transactionFunctions,
            onTypeFolderClickWrapper: CustFolderClickWrapper,
            hideTopStep: true }, `customerRollingProgrammes`) }, 'RollingProgrammes')));
};
